export default function formatMessageContentVideo ({
    url,
    name,
    size,
    type = 'video' // 后端传来的video类型可能没有type字段
    // duration = 0
}) {
    return {
        fileName: name,
        fileSize: Number(size),
        url,
        type
        // name,
        // size: Number(size),
        // duration: Math.ceil(duration)
    }
}
